<template>
  <div id="app">
    <HeaderView />
    <router-view />
    <FooterView :hideLinks="hideFooterLinks" />
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
    hideFooterLinks() {
      // Hide footer links only on end page
      return this.$route.name === 'end';
    },
  },
};
</script>
